(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("ontime-layout", ["PropTypes", "React"], factory);
	else if(typeof exports === 'object')
		exports["ontime-layout"] = factory(require("prop-types"), require("react"));
	else
		root["ontime-layout"] = factory(root["PropTypes"], root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__11__) {
return 